(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@deck.gl/layers"), require("@deck.gl/core"), require("@luma.gl/core"), require("@luma.gl/constants"));
	else if(typeof define === 'function' && define.amd)
		define(["@deck.gl/layers", "@deck.gl/core", "@luma.gl/core", "@luma.gl/constants"], factory);
	else if(typeof exports === 'object')
		exports["phylocanvas"] = factory(require("@deck.gl/layers"), require("@deck.gl/core"), require("@luma.gl/core"), require("@luma.gl/constants"));
	else
		root["phylocanvas"] = factory(root["@deck.gl/layers"], root["@deck.gl/core"], root["@luma.gl/core"], root["@luma.gl/constants"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__23__, __WEBPACK_EXTERNAL_MODULE__28__) {
return 